import React, { useRef } from 'react';
import { createRoot } from 'react-dom/client';
import stringUtils from '../../utils/string.utils';

const NewsSearchBox = () => {
    const keywordRef = useRef();

    const onSubmit = (e) => {
        if (stringUtils.isNullOrEmpty(keywordRef.current.value)) {
            e.preventDefault();
        }
    };

    return (
        <aside className="widget widget_search" onSubmit={onSubmit}>
            <div className="search-form">
                <form action="/tim-kiem/tin-tuc" method="get">
                    <input
                        ref={keywordRef}
                        type="text"
                        placeholder="Tìm kiếm..."
                        defaultValue=""
                        className="ajax_autosuggest_input ac_input"
                        name="keyword"
                    />
                    <button type="submit" className="icon-search">
                        <i className="icons icon-magnifier"></i>
                    </button>
                </form>
            </div>
        </aside>
    );
};

NewsSearchBox.propTypes = {};

export default NewsSearchBox;

document.querySelectorAll('react-news-search-box').forEach((domContainer) => {
    const root = createRoot(domContainer);
    root.render(<NewsSearchBox />);
});
